<template>
    <div class="technicalservice">
        <div class="technicalservice-title">{{ typeName }}</div>
        <div class="title_tap" style="text-align: center">
            请完整准确填写您的需求，我们将尽快回复您
        </div>
        <el-form
            ref="ruleFormRef"
            :model="ruleForm"
            :rules="rules"
            label-width="129px"
            label-position="left"
            class="technicalservice-form"
        >
            <div>
                <div class="goods-box">
                    <div class="title">
                        <p>型号</p>
                        <p>商品信息</p>
                        <p>需求数量（个）<span>*</span></p>
                        <p>目标价（元）</p>
                    </div>
                    <div class="inner">
                        <div class="inner-box">
                            <p class="no-wrap-once go-details" @click="goDetails(detailsData.id)">{{ detailsData.m }}</p>
                        </div>
                        <div class="inner-box">
                            <p class="no-wrap-once">
                                品牌：{{ detailsData?.brandVO?.name || '-' }}
                            </p>
                            <p class="no-wrap-once">
                                商品分类：{{ detailsData.c3n || '-' }}
                            </p>
                            <p class="no-wrap-once">
                                封装：{{ detailsData.ps || '-' }}
                            </p>
                            <p class="no-wrap-once">
                                包装方式：{{ detailsData.spec || '-' }}
                            </p>
                        </div>
                        <div class="inner-box">
                            <el-form-item prop="requireQuantity">
                                <el-input
                                    placeholder="请输入需求数量"
                                    v-model.trim="ruleForm.requireQuantity"
                                    class="inner-box-number"
                                    clearable
                                    maxlength="7"
                                >
                                    <!-- @input="requireQuantityChange" -->
                                </el-input>
                            </el-form-item>
                        </div>
                        <div class="inner-box">
                            <el-form-item prop="requirePrice">

                                    <!-- @blur="handleBlurrequirePrice"
                                    @input="requirePriceChange" -->
                                <el-input
                                    placeholder="请输入目标价"
                                    v-model.trim="ruleForm.requirePrice"
                                    class="inner-box-number"
                                    style="width: 164px"
                                    clearable
                                >
                                </el-input>
                            </el-form-item>
                        </div>
                    </div>
                </div>
                <el-form-item
                    prop="requireTimeRange"
                    label="期望交期"
                    class="date-item"
                >
                    <el-radio-group v-model="ruleForm.requireTimeRange">
                        <el-radio value="NO_REQUIRE">无要求</el-radio>
                        <el-radio value="ONE_WEEK_WITHIN">一周以内</el-radio>
                        <el-radio value="TWO_WEEK_WITHIN">两周以内</el-radio>
                        <el-radio value="ONE_MONTH_WITHIN">一个月以内</el-radio>
                        <el-radio value="OTHER">其他</el-radio>
                    </el-radio-group>
                    <el-input
                        placeholder="请输入期望交期：如60"
                        v-if="ruleForm.requireTimeRange === 'OTHER'"
                        v-model="ruleForm.requireDay"
                        v-trim
                        class="requireTimeRange"
                        clearable
                        maxlength="7"
                    >
                    <template #suffix>
                        <span style="color: #333;">工作日</span>
                    </template>
                        <!-- @input="requireDayChange" -->
                    </el-input>
                </el-form-item>
                <el-form-item
                    prop="remark"
                    label="需求描述"
                    class="describes_item"
                >
                    <el-input
                        v-model="ruleForm.remark"
                        v-trim
                        maxlength="180"
                        placeholder="填写询价的具体描述、备注等"
                        show-word-limit
                        type="textarea"
                        :autosize="false"
                    />
                </el-form-item>
                <el-form-item prop="companyName" label="企业名称">
                    <el-autocomplete
                        class="w-410"
                        v-model.trim="ruleForm.companyName"
                        maxlength="100"
                        clearable
                        :fetch-suggestions="querySearchAsync"
                        placeholder="请输入企业名称"
                        show-word-limit
                        debounce="0"
                    />
                </el-form-item>
                <el-form-item prop="contacts" label="姓名">
                    <el-input
                        placeholder="请输入姓名"
                        v-model.trim="ruleForm.contacts"
                        show-word-limit
                        clearable
                        maxlength="10"
                    >
                    </el-input>
                </el-form-item>
                <el-form-item prop="officeEmail" label="工作邮箱">
                    <el-input
                        placeholder="请输入工作邮箱"
                        v-model.trim="ruleForm.officeEmail"
                        clearable
                        show-word-limit
                        maxlength="100"
                    >
                    </el-input>
                </el-form-item>
                <el-form-item prop="customerPhone" label="手机号">
                    <el-input
                        placeholder="请填写联系人手机号码"
                        v-model="ruleForm.customerPhone"
                        v-trim
                        class="w-370"
                        clearable
                        @change="contactNumberChange()"
                        maxlength="11"
                        :disabled="isPhone(store.userInfo.phone)"
                    >
                    </el-input>
                </el-form-item>
                <el-form-item
                    prop="code"
                    label="验证码"
                    v-if="!isLogin && isPhone(ruleForm.customerPhone)"
                >
                    <codeInput
                        @codeInputChange="codeInputChangeFa"
                        :phone="ruleForm.customerPhone"
                    ></codeInput>
                </el-form-item>
            </div>
        </el-form>
        <el-checkbox class="login-checkBox" v-model="isAgree" v-if="!isLogin">
            <p>
                验证成功后将自动注册，阅读并同意<a
                    href="#"
                    @click="getPrivateApi('2533592194358509568')"
                    >《用户服务协议》</a
                >和<a href="#" @click="getPrivateApi('2533591881094332416')">《隐私政策》</a>
            </p>
        </el-checkbox>
        <div class="addbtn_box">
            <el-button
                color="#0071DC"
                class="submit"
                @click="submitForm(ruleFormRef)"
            >
                提交
            </el-button>
        </div>
    </div>
    <ZDialog
        :dialog-object="dialogObjDelDef"
        @dialogClose="dialogCloseDef"
        class="private-dialog"
    >
        <div v-html="Sprivate" class="private"></div>
    </ZDialog>
</template>
<script lang="ts">
import {
    reactive,
    toRefs,
    defineComponent,
    ref,
    getCurrentInstance,
    onMounted,
} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useUserStore } from '@/store/User';
import orderApi from '@/api/PcModule/order';
import goodsApi from '@/api/PcModule/goods';
import minesApi from '@/api/PcModule/mine';
import loginApi from '@/api/PcModule/login';
import { ElMessage } from 'element-plus';
import localStorageUtils from '@/utils/localstorage';
import VueCookies from 'vue-cookies';
import { useShopStore } from '@/store/Shop';
import { getPrivate } from '@/api/PcModule/home';
import ZDialog from '@/components/ZDialog.vue';
import {
    isPhone,
    isCodeEmpty,
    isName,
    isPasswordisEmail,
    validateNumber,
    Reg_Number,
} from '@/utils/validate';
export default defineComponent({
    name: 'Service',
    components: {
        ZDialog,
    },
    setup() {
        const { proxy } = getCurrentInstance();
        let router = useRouter();
        let route = useRoute();
        const store = useUserStore();
        const storeShop = useShopStore();
        const data = reactive({
            typeName: '询价',
            detailsData: {},
            isLogin: true,
            isAgree: false,
            registerFlag: false,
            private: '',
        });

        const refData = toRefs(data);
        onMounted(() => {
            contactNumberChange();
            getDetailsAction();
        });
        const getDetailsAction = async () => {
            let data = await goodsApi.getDetails({
                spuId: route.query.id,
            });
            if (data.code == 200) {
                refData.detailsData.value = data.data || {};
            }
        };
        const ruleFormRef = ref<FormInstance>();
        let ruleForm = reactive({
            requireQuantity: '',
            requirePrice: '',
            requireTimeRange: '',
            requireDay: '',
            remark: '',
            companyName: '',
            contacts: '',
            officeEmail: '',
            customerPhone: '',
            consultType: 'PRICE',
            spuId: route.query.id,
            code: '',
        });
        let formSave = reactive({});
        const validateCompany = (rule: any, value: any, callback: any) => {
            if (value != '') {
                if (!isCodeEmpty(value)) {
                    callback(new Error('请输入正确的企业名称'));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        };
        //企业认证名称校验
        const validateApplyName = (rule: any, value: any, callback: any) => {
            if (value != '') {
                if (!isName(value)) {
                    callback(new Error('请输入正确的姓名'));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        };

        const isExistPhoneAction = async (value: number | string) => {
            let params = {
                username: value,
            };
            let data = await loginApi.IsExistPhone(params);
            if (data.code == 200) {
                return data.data;
            }
        };
        const validatePhone = (rule: any, value: any, callback: any) => {
            if (value != '') {
                if (!isPhone(value)) {
                    callback(new Error('请输入正确的手机号'));
                } else {
                    isExistPhoneAction(value).then((data) => {
                        if (data) {
                            refData.registerFlag.value = false;
                            callback();
                        } else {
                            refData.registerFlag.value = true;
                            callback();
                        }
                    });
                }
            } else {
                callback();
            }
        };
        const validateEmail = (rule: any, value: any, callback: any) => {
            if (value != '') {
                if (!isPasswordisEmail(value)) {
                    callback(new Error('请输入正确的邮箱'));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        };
        const validateCode = (rule: any, value: any, callback: any) => {
            if (value == '') {
                callback(new Error('验证码不能为空'));
            } else {
                callback();
            }
        };
        const validateRequirePrice = (rule: any, value: any, callback: any) => {
            if (value == '') {
                callback();
            } else {
                ruleForm.requirePrice = Number(value)
                if (!validateNumber(ruleForm.requirePrice)) {
                    callback(new Error('请输入正确的目标价'));
                    ruleForm.requirePrice = ''
                } else if(Number(ruleForm.requirePrice) > 9999999){
                    callback(new Error('请输入正确的目标价'));
                }else {
                    callback();
                }
            }
        };
        
        const rules = reactive({
            requireTimeRange: [
                {
                    required: true,
                    message: '请选择期望交期',
                    trigger: 'blur',
                },
                {
                    required: true,
                    validator: (rule: any, value: any, callback: any) => {
                        console.log(ruleForm.requireTimeRange === 'OTHER' , Number(ruleForm.requireDay) <= 0 , Reg_Number(ruleForm.requireDay), '2222')
                        if (ruleForm.requireTimeRange === 'OTHER') {
                            if(Reg_Number(ruleForm.requireDay)){
                                if(Number(ruleForm.requireDay) <= 0){
                                    callback(new Error('请输入大于0的正整数'));
                                }else{
                                    callback();
                                }
                            }else{
                                callback(new Error('请输入大于0的正整数'));
                            }
                        } else {
                            callback();
                        }
                    },
                    trigger: 'blur',
                },
            ],
            requireQuantity: [
                {
                    required: true,
                    message: '请填写需求数量',
                    trigger: 'blur',
                },
                {
                    validator: (rule: any, value: any, callback: any) => {
                        if(!Reg_Number(value)){
                            callback(new Error('请输入正确的需求数量'));
                        }else if (Number(value) <= 0) {
                            callback(new Error('需求数量至少为1'));
                        } else {
                            callback();
                        }
                    },
                    trigger: 'blur',
                },
            ],
            companyName: [
                {
                    required: true,
                    message: '请输入企业名称',
                    trigger: 'blur',
                },
                {
                    validator: validateCompany,
                    trigger: 'blur',
                },
            ],
            contacts: [
                {
                    required: true,
                    message: '请输入姓名',
                    trigger: 'blur',
                },
                {
                    validator: validateApplyName,
                    trigger: 'blur',
                },
            ],
            customerPhone: [
                {
                    required: true,
                    message: '请输入联系电话',
                    trigger: 'blur',
                },
                {
                    validator: validatePhone,
                    trigger: 'blur',
                },
            ],
            officeEmail: [
                {
                    required: true,
                    message: '请输入邮箱',
                    trigger: 'blur',
                },
                {
                    validator: validateEmail,
                    trigger: 'change',
                },
            ],
            code: [
                {
                    required: true,
                    validator: validateCode,
                    trigger: 'blur',
                },
            ],
            requirePrice: [
                {
                    validator: validateRequirePrice,
                    trigger: 'blur',
                },
            ],
        });
        const requireQuantityChange = (value: string) => {
            let num = value.replace(/[^0-9]/g, '');
            ruleForm.requireQuantity = Number(num) + ''
        };
        const requireDayChange = (value: string) => {
            let num = value.replace(/[^0-9]/g, '');
            ruleForm.requireDay = Number(num) + ''
        };
        const requirePriceChange = (value: string) => {
            let filteredValue = value.replace(/[^\d.]/g, '');
            if (filteredValue.startsWith('.')) {
                filteredValue = '0' + filteredValue;
            }
            const firstDotIndex = filteredValue.indexOf('.');
            if (firstDotIndex !== -1) {
                const beforeDot = filteredValue.substring(0, firstDotIndex + 1);
                const afterDot = filteredValue
                    .substring(firstDotIndex + 1)
                    .replace(/\./g, '');
                filteredValue = beforeDot + afterDot;
            }
            const dotIndex = filteredValue.indexOf('.');
            if (dotIndex !== -1) {
                const decimalPart = filteredValue.substring(dotIndex + 1);
                if (decimalPart.length > 6) {
                    filteredValue = filteredValue.substring(0, dotIndex + 7);
                }
            }
            ruleForm.requirePrice = filteredValue;
        };
        const handleBlurrequirePrice = () => {
            if (ruleForm.requirePrice === '' || ruleForm.requirePrice === '.') {
                ruleForm.requirePrice = '0.000001';
            }
            const numValue = parseFloat(ruleForm.requirePrice);
            if (isNaN(numValue)) {
                ruleForm.requirePrice = '0.000001';
                return;
            }
            if (numValue > 9999999) {
                ruleForm.requirePrice = '9999999';
            } else if (numValue < 0.000001) {
                ruleForm.requirePrice = '0.000001';
            } else {
                // 格式化为标准数字字符串（移除多余的零）
                ruleForm.requirePrice = numValue.toString();
            }
        };
        const chineseNameList = ref([]); // 116接口获取的值
        // 防抖用
        let timmer = undefined;
        // 自动补全
        const querySearchAsync = (queryString: string, cb: any) => {
            // 输入的字符长度需要大于4
            if (queryString.length < 4) {
                cb([]);
                return;
            }
            // 防抖
            if (timmer) {
                cb([]);
                clearTimeout(timmer);
            }
            timmer = setTimeout(async () => {
                const res: any = await minesApi.search816({
                    word: queryString,
                    pageNum: 1,
                    pageSize: 20,
                });
                if (res.result) {
                    chineseNameList.value = res.result?.items || [];
                    chineseNameList.value.map((item) => {
                        item.value = item.name;
                    });
                    cb(chineseNameList.value);
                } else {
                    cb([]);
                }
            }, 1000);
        };
        const getLastPassByUserId = async () => {
            let data = await minesApi.getLastPassByUserId({
                userId: store.userInfo.id,
            });
            if (data.code === 200) {
                ruleForm.companyName = data.data.company;
                ruleForm.contacts = data.data.name;
                ruleForm.officeEmail = data.data.email;
            }
        };
        //判断是否登录
        const contactNumberChange = () => {
            if (store.userInfo.id) {
                refData.isLogin.value = true;
                ruleForm.customerPhone = store.userInfo.phone;
                getLastPassByUserId();
            } else {
                refData.isLogin.value = false;
            }
        };
        const codeInputChangeFa = (code) => {
            ruleForm.code = code || '';
        };

        // 确定
        const submitForm = async (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            await formEl.validate(async (valid, fields) => {
                if (valid) {
                    let params = {};
                    params.requireQuantity = ruleForm.requireQuantity;
                    params.requirePrice = ruleForm.requirePrice;
                    params.requireTimeRange = ruleForm.requireTimeRange;
                    params.requireDay = ruleForm.requireTimeRange === 'OTHER' ? ruleForm.requireDay : '';
                    params.remark = ruleForm.remark;
                    params.companyName = ruleForm.companyName;
                    params.contacts = ruleForm.contacts;
                    params.officeEmail = ruleForm.officeEmail;
                    params.consultType = ruleForm.consultType;
                    params.customerPhone = ruleForm.customerPhone;
                    params.spuId = ruleForm.spuId;
                    // 判断是否登录
                    if (store.userInfo.id) {
                        submitYes(params);
                    } else {
                        if (!refData.isAgree.value) {
                            proxy.$msg.error('请同意用户服务协议等内容！');
                            return;
                        } else {
                            if (refData.registerFlag.value) {
                                registerPhone(params);
                            } else {
                                goLogin(params);
                            }
                        }
                    }
                }
            });
        };
        // 注册
        const registerPhone = async (info) => {
            let params = {
                code: ruleForm.code,
                phone: ruleForm.customerPhone,
                origin: 0,
            };
            let data = await loginApi.RegisterPhone(params);
            if (data.code == 200) {
                store.onceLogin = '1';
                goLogin(info);
            } else {
                ElMessage.closeAll();
                ElMessage.error(data.message);
            }
        };
        const goLogin = async (infos) => {
            let params = {};
            params.grant_type = 'sms';
            params.code = ruleForm.code;
            params.username =
                '2287838788945248256????2????' + ruleForm.customerPhone;
            params.captcha_type = formSave.captcha_type;
            params.point_json = formSave.point_json;
            params.result = formSave.result;
            params.token = formSave.token;
            params.unionid = '';
            let data = await loginApi.LoginCodeUser(params);
            if (data.access_token) {
                store.userInfo = data.user;
                store.userInfo.access_token = data.access_token;
                localStorageUtils.set('userInfo', data);
                let info = await minesApi
                    .getUserDetail({
                        memberId: store.userInfo.id,
                    })
                    .then((res) => {
                        store.userInfo.pic = res.data.avatar;
                        store.userInfo.nickname = res.data.nickName;
                        // storeShop.getShopAction();
                        // storeShop.getCanSampleApplyAction();
                        VueCookies.set(
                            'token',
                            data.access_token,
                            data.expires_in + 28800,
                        );
                        localStorage.setItem(
                            'refresh_token',
                            data.refresh_token,
                        );
                        const now = new Date();
                        now.setSeconds(
                            now.getSeconds() + data.expires_in + 28800,
                        );
                        localStorage.setItem('expires_in', now);
                    });
                submitYes(infos);
            } else {
                ElMessage.error(data.message);
            }
        };
        const submitYes = async (params: object) => {
            let data = await orderApi.consultAdd(params);
            if (data.code == 200) {
                proxy.$msg.success('申请成功！');
                ruleForm.requireQuantity = '';
                ruleForm.requireTimeRange = '';
                ruleForm.remark = '';
                router.replace({
                    name: 'mineConsult',
                });
            }
        };
        // 用户协议和隐私政策弹窗用
        const Sprivate = ref('');
        const dialogObjDelDef = reactive({
            dialogVisible: false,
            title: '',
            width: '916px',
            isFooter: false, // 是否显示按钮
        });
        // 获取用户协议和隐私政策数据
        const getPrivateApi = async (id) => {
            const newArr = store.private.filter((item) => {
                return item.id == id;
            });
            if (newArr.length <= 0) {
                store.getPrivateApi(id);
                setTimeout(() => {
                    dialogObjDelDef.dialogVisible = true;
                    dialogObjDelDef.title =
                        store.private[store.private.length - 1].title;
                    Sprivate.value = store.private[store.private.length - 1].content;
                }, 300);
            } else {
                dialogObjDelDef.dialogVisible = true;
                dialogObjDelDef.title = newArr[0].title;
                Sprivate.value = newArr[0].content;
            }
        };

        // 关闭服务协议、隐私政策弹窗
        const dialogCloseDef = () => {
            dialogObjDelDef.dialogVisible = false;
        };
        // 商品详情
        const goDetails = (id: string) => {
            if (id) {
                window.open(import.meta.env.VITE_SEO_HOST + '/details/' + id + '.html');
            }
        };
        return {
            ...refData,
            ruleFormRef,
            ruleForm,
            rules,
            isPhone,
            submitForm,
            requireQuantityChange,
            requirePriceChange,
            handleBlurrequirePrice,
            querySearchAsync,
            contactNumberChange,
            codeInputChangeFa,
            getPrivateApi,
            dialogObjDelDef,
            store,
            requireDayChange,
            goDetails,
            dialogCloseDef,
            Sprivate,
        };
    },
});
</script>
<style scoped lang="scss">
.home {
    background-color: #f4f8fe;
}

.technicalservice {
    width: 1200px;
    background: #fff;
    border-radius: 10px;
    margin: 0 auto;
    padding-top: 24px;
    padding-bottom: 30px;
    .technicalservice-title {
        width: 100%;
        text-align: center;
        font-size: 24px;
        color: #333333;
        font-weight: 700;
        margin-bottom: 6px;
    }

    .title_tap {
        width: 100%;
        font-size: 14px;
        color: #bebebe;
        margin-bottom: 20px;
    }
    .submit {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 184px;
        height: 48px;
        font-size: 16px;
        background: $font-color;
        border: 1px solid $font-color;
        color: #ffffff;
        border-radius: 8px;
        margin: 0 auto;
        span{
            font-size: 16px;
        }
    }
}
.login-checkBox {
    margin-left: 140px;
    p {
        font-size: 12px;
        line-height: 140%;
        color: #828282;
        width: 378px;
        word-break: normal;
        white-space: pre-wrap;
        word-wrap: break-word;

        a {
            font-size: 12px;
            line-height: 16px;
            color: $font-color;
        }
    }
}
</style>

<style lang="scss">
.submit {
    span{
        font-size: 16px;
    }
}
.el-popper.el-select__popper {
    z-index: 15 !important;
}
.technicalservice-form {
    width: 920px;
    margin: 0 auto;
    .goods-box {
        border-radius: 8px;
        border: 1px solid #e1e5ee;
        width: 920px;
        height: 144px;
        box-sizing: border-box;
        margin-bottom: 20px;
        .title {
            border-radius: 8px 8px 0px 0px;
            background: #f7f8fa;
            display: flex;
            align-items: center;
            p {
                // text-align: center;
                padding-left: 20px;
                color: #000;
                font-family: '思源黑体 CN';
                font-size: 14px;
                font-weight: 749;
                border-right: 1px solid #e1e5ee;
                height: 32px;
                line-height: 32px;
                box-sizing: border-box;
                span {
                    color: #cd4040;
                    font-size: 14px;
                    font-weight: 749;
                }
            }
            p:nth-of-type(1) {
                width: 188px;
                min-width: 188px;
            }
            p:nth-of-type(2) {
                width: 304px;
                min-width: 304px;
            }
            p:nth-of-type(3) {
                width: 223px;
                min-width: 223px;
            }
            p:nth-of-type(4) {
                width: 203px;
                min-width: 203px;
                border-right: 0;
            }
        }
        .inner {
            display: flex;
            .inner-box {
                height: 110px;
                border-right: 1px solid #e1e5ee;
                p {
                    color: #000;
                    font-size: 12px;
                }
                .inner-box-number {
                    width: 184px;
                    height: 32px;
                    border-radius: 4px;
                    margin-left: 20px;
                }
                .el-form-item__error {
                    margin-left: 20px;
                }
                .el-form-item__content {
                    margin-left: 0 !important;
                }
                .go-details{
                    cursor: pointer;
                }
                .go-details:hover{
                    color: $font-color;
                }
            }
            .inner-box:nth-of-type(1) {
                // text-align: center;
                width: 187px;
                min-width: 187px;
                margin: 0 auto 0;
                padding-top: 49px;
                padding-left: 20px;
                box-sizing: border-box;
            }
            .inner-box:nth-of-type(2) {
                width: 303px;
                min-width: 303px;
                padding: 20px 0 0 16px;
                box-sizing: border-box;
                p {
                    margin-bottom: 8px;
                }
            }
            .inner-box:nth-of-type(3) {
                width: 223px;
                min-width: 223px;
                padding-top: 40px;
                box-sizing: border-box;
            }
            .inner-box:nth-of-type(4) {
                width: 203px;
                min-width: 203px;
                border-right: 0;
                padding-top: 40px;
                box-sizing: border-box;
            }
        }
    }
    .el-textarea__inner {
        resize: none;
        /* 禁止拖动调整大小 */
        min-height: 95px !important;
        height: 95px !important;
    }
    //表单必选项最前面的“*”样式
    .el-form-item.is-required:not(.is-no-asterisk)
        > .el-form-item__label-wrap
        > .el-form-item__label:before,
    .el-form-item.is-required:not(.is-no-asterisk)
        > .el-form-item__label:before {
        margin-top: 3px;
    }

    .el-form-item.is-required:not(.is-no-asterisk).asterisk-left
        > .el-form-item__label-wrap
        > .el-form-item__label:before,
    .el-form-item.is-required:not(.is-no-asterisk).asterisk-left
        > .el-form-item__label:before {
        display: none;
    }

    .el-form-item.is-required:not(.is-no-asterisk).asterisk-left
        > .el-form-item__label-wrap
        > .el-form-item__label:after,
    .el-form-item.is-required:not(.is-no-asterisk).asterisk-left
        > .el-form-item__label:after {
        content: '*';
        color: #cd4040;
        font-size: 16px;
        display: block;
        margin-top: 4px;
        margin-left: 6px;
        font-weight: 600;
    }
    .el-input {
        height: 40px;
        border-radius: 6px;
    }
    .codeInput {
        display: flex;
        align-items: center;
    }
    .codeInput .verifyCode-btn {
        border-radius: 6px !important;
        margin-left: 20px !important;
    }
}

.date-item {
    display: flex;
    align-items: center;
    .el-form-item__content {
        height: 40px !important;
    }
    .el-radio {
        margin-right: 27px !important;
    }
    .el-radio:last-of-type {
        margin-right: 0 !important;
    }
    .requireTimeRange {
        width: 299px;
        height: 40px;
        border-radius: 6px;
        margin-left: 22px;
    }
}
</style>
